'use strict';

export { default } from './errorBoundary.component';